import "./RoboticsCourseD3.module.css";
import Header from "@/reusable_sections/Header";
import CourseDetail from "./sections/CourseDetail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseD3Page() {
  return <div>
      <Header />
      <CourseDetail />
      <Footer />
    </div>;
}